<template>
    <div class="userLogo">
      <div class="ant-upload-preview" @click="changeHeadimg" >
<!--        <a-icon type="cloud-upload-o" class="upload-icon"/>-->
        <div class="mask">
          <a-icon type="plus" />
        </div>
        <!--<img :src="url?url:getImageUrl()" class="image" alt="">-->
        <a-avatar icon="user" :size="85" :src="url?url:getImageUrl()"/>
      </div>
      <div v-if="isBirthDay" class="hatIcon">
        <pt-icon type="icon-shengrimao"></pt-icon>
      </div>

<!--      <div class="level">-->
<!--        LV4-->
<!--      </div>-->
      <div class="userName">
        {{userInfo.employeeDO.userName}}
      </div>
      <avatar-modal ref="modal" @ok="getImageUrl"></avatar-modal>
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import AvatarModal from './AvatarModal'
  import {selectBirthDay} from '@/api/login'
  export default {
    name: 'UserLogo',
    components:{
      AvatarModal
    },
    data(){
      return {
        url:'',
        isBirthDay:false,
      }
    },
    computed:{
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    mounted(){
      this.queryBirthday();
    },
    methods:{
      queryBirthday(){
        selectBirthDay(this.userInfo.accountDO.loginName).then(res=>{
          if(res.code == 1){
            this.isBirthDay = res.data
          }
        })
      },
      getImageUrl(fileId){
        if(fileId){
          let url = this.$util.getFileUrl(fileId)
          this.url = url
        }else{
          let url = this.$util.getFileUrl(this.userInfo.employeeDO.headimg)
          this.url = url
        }
      },
      changeHeadimg(){
        console.log(this.url)
        this.$refs.modal.edit(this.url)
      },
    }
  }
</script>

<style scoped lang="less">
  .userLogo{
    margin-top: 30px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;
    .hatIcon{
      position: absolute;
      top: -18px;
      right: 30px;
      font-size: 36px;
    }
    .image{
      width: 84px;
      height: 84px;
      border-radius: 50%;
    }
    .level{
      font-size: 14px;
      background: #fabe00;
      color: #fff;
      padding: 0 5px;
      margin-top: 5px;
    }
    .userName{
      margin-top: 10px;
      font-size: 12px;
      color: #333333;
    }
  }


  .ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    height: 84px;
    max-width: 84px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;
    .upload-icon {
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 1.4rem;
      padding: 0.5rem;
      background: rgba(222, 221, 221, 0.7);
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .mask {
      opacity: 0;
      position: absolute;
      background: rgba(0,0,0,0.4);
      cursor: pointer;
      transition: opacity 0.4s;
      &:hover {
        opacity: 1;
      }
      i {
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: #d6d6d6;
      }
    }
    img, .mask {
      width: 100%;
      max-width: 84px;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>